import { createContext } from 'react';
import {
  type RubricsPortfolio,
  type SetComplexImmerStateAction,
} from '../types';

const RubricsPortfolioContext = createContext<
  [RubricsPortfolio, SetComplexImmerStateAction<RubricsPortfolio>]
>([null as unknown as RubricsPortfolio, () => {}]);

export default RubricsPortfolioContext;
